import { Loader2, Save, Undo2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

// Sticky bottom save bar (translates the design's HMSaveBar): a left actions slot plus the
// "Unsaved changes" indicator, Discard, and the primary "Save for everyone".
export function SaveBar({
  dirty,
  saving = false,
  canSave = true,
  onSave,
  onDiscard,
  leftActions = null,
  saveLabel = 'Save for everyone',
}) {
  return (
    <div className="flex shrink-0 items-center gap-2.5 border-t border-border bg-background px-6 py-3">
      {leftActions}
      <div className="ml-auto flex items-center gap-2.5">
        {dirty ? (
          <span className="inline-flex items-center gap-1.5 text-[12.5px] font-semibold text-muted-foreground">
            <span className="h-1.5 w-1.5 rounded-full bg-primary" /> Unsaved changes
          </span>
        ) : null}
        {dirty ? (
          <Button type="button" variant="ghost" size="sm" onClick={onDiscard} disabled={saving}>
            <Undo2 className="mr-1.5 h-3.5 w-3.5" aria-hidden />
            Discard
          </Button>
        ) : null}
        <Button type="button" size="sm" onClick={onSave} disabled={!canSave || !dirty || saving}>
          {saving ? (
            <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" aria-hidden />
          ) : (
            <Save className="mr-1.5 h-3.5 w-3.5" aria-hidden />
          )}
          {saveLabel}
        </Button>
      </div>
    </div>
  );
}
